export const LOGIN_HERO_IMG =
  "https://images.unsplash.com/photo-1585829365671-3ef0e1553a66?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80";
